/* global app */
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
// import { SBPayments } from 'sb-payments-totalbet'

// const { PaymentHeader } = SBPayments

const Blik = ({ isLogged, goToPayments }) => {

  // const lang = useMemo(() => `lang_${app.config.lang}_${app.config.mainCountryCode}_1_2`.toLowerCase(), [
  //   app.config.lang, app.config.mainCountryCode
  // ])

  // return (
  //   isLogged && <PaymentHeader lang={lang} goToPayments={goToPayments} />
  // )

  return null;
}

const mapStateToProps = ({ Auth: { isLogged } }) => {
  return {
    isLogged
  }
}

export default connect(mapStateToProps)(Blik)
